import React from 'react';

export default class Ribbon extends React.Component {
    render() {
        return (
            <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                width: 250,
                height: 250,
                overflow: 'hidden',
                textAlign: 'center',
                verticalAlign: 'center'
            }}
            >
                <div
                    style={{
                        boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.14)",
                        position: "absolute",
                        left: -125,
                        top: 25,
                        width: 350,
                        height: 50,
                        textAlign: 'center',
                        verticalAlign: 'center',
                        backgroundColor: this.props.backgroundColor,
                        padding: '10 100',
                        color: '#fff',
                        transform: 'rotate(-45deg)'
                    }}
                >
                    <div
                        style={{
                            paddingTop: 14,
                            fontWeight: 'bold',
                            letterSpacing: 1.5
                        }}
                    >
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}